import { Injectable } from '@angular/core';
import {
  ManagementUserAccountService as ManagementUserAccountApiService,
} from '../../../../api/gen/api/api/managementUserAccount.service';
import {
  CreateManagementUserAccountDto,
  CreateManagementUserAccountLicenseRequestDto,
  UpdateManagementUserAccountDto,
} from '../../../../api/gen/api';

@Injectable({
  providedIn: 'root',
})
export class ManagementUserService {
  constructor(private defaultService: ManagementUserAccountApiService) {}

  getActiveLicense() {
    return this.defaultService.managementManagementUserAccountActiveLicenseGet();
  }

  getManagementUserAccount() {
    return this.defaultService.managementManagementUserAccountsGet();
  }

  getLicenseRequests() {
    return this.defaultService.managementManagementUserAccountLicenseRequestsGet();
  }

  getLicenses() {
    return this.defaultService.managementManagementUserAccountLicensesGet();
  }

  createAccount(accountData: CreateManagementUserAccountDto) {
    return this.defaultService.managementManagementUserAccountsPost(accountData);
  }

  requestLicense(licenseRequest: CreateManagementUserAccountLicenseRequestDto) {
    return this.defaultService.managementManagementUserAccountLicensesRequestPost(licenseRequest);
  }

  updateAccount(accountData: UpdateManagementUserAccountDto) {
    return this.defaultService.managementManagementUserAccountsWithUserAccountPut(accountData);
  }
}
